import { useState, useRef } from "react";
import css from "./Reviews.module.css";

const defaultReviews = [
  {
    text: "As someone who's always prided himself on having the best people in every aspect of the business, bringing Crystal Clear Consulting on board has hands-down been one of the smartest moves I've ever made...",
    author: "Armormax Ghana",
  },
  {
    text: "Great service! Kind and understanding. Knows what she is doing and works well with both large and small businesses. I highly recommend her.",
    author: "TJ Holdman",
  },
  {
    text: "Working with Crystal Clear consulting has been one of the best decisions I have made for my business. It has lightened my load tremendously and has provided me with so much extra time to invest in different ways in my business.",
    author: "Salon on State",
  },
  
];

const SWIPE_THRESHOLD = 50;

const Reviews = ({ reviews }) => {
  const [current, setCurrent] = useState(0);
  const touchStartX = useRef(null);
  const touchEndX = useRef(null);

  const goNext = () => setCurrent((old) => (old + 1) % displayedReviews.length);
  const goPrev = () =>
    setCurrent(
      (old) => (old - 1 + displayedReviews.length) % displayedReviews.length,
    );

  const handleTouchStart = (e) => {
    touchEndX.current = null;
    touchStartX.current = e.targetTouches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.targetTouches[0].clientX;
  };

  const handleTouchEnd = () => {
    if (touchStartX.current === null || touchEndX.current === null) return;

    const distance = touchStartX.current - touchEndX.current;

    if (distance > SWIPE_THRESHOLD) {
      goNext(); // swiped left -> next
    } else if (distance < -SWIPE_THRESHOLD) {
      goPrev(); // swiped right -> previous
    }

    touchStartX.current = null;
    touchEndX.current = null;
  };

  const displayedReviews = reviews || defaultReviews;

  return (
    <div className={css.background}>
      <div className={css.main}>
        <div className={css.stars}>
          {[...Array(5)].map((_, i) => (
            <img
              key={i}
              className={css.star}
              src={require("../../images/star.png")}
              alt="star"
            />
          ))}
        </div>
        <div
          className={css.reviews}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          {displayedReviews.map((review, i) => (
            <div
              key={i}
              className={`${css.review} ${i === current ? css.visible : css.invisible}`}
            >
              <p className={css.content}>"{review.text}"</p>
              <p>
                <strong className={css.author}>— {review.author}</strong>
              </p>
            </div>
          ))}
        </div>
        <div className={css.dots}>
          {displayedReviews.map((_, i) => (
            <button
              key={i}
              className={css.dot_container}
              onClick={() => setCurrent(i)}
              aria-label={`Go to slide ${i + 1}`}
            >
              <div
                className={`${css.dot} ${i === current ? css.dot_active : ""}`}
              />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Reviews;
